export const constants = {
  bookOfBusinessEndPoint: 'aipdashboardms/getYtdMtdCurrentBookOfBusiness',
  currentBoBForFromToDateEndPoint: 'aipdashboardms/getCurrentBoBForFromToDate',
  actionItemsEndPoint: 'aipdashboardms/getActionItems',
  permissionEndPoint: 'aipauth0api/getRolesAndPortals',
  bopQuoteEndPoint: 'api/quote',
  paymentScheduleEndpoint: 'billing-portal-api/paymentSchedule',
  initializePaymentEndPoint: 'billing-portal-api/initializePayment',
  paymentQueryEndpoint: 'billing-portal-api/paymentQuery',
  updateCardEndPoint: 'billing-portal-api/updateCard/',
  getPolicyEndPoint: 'billing-portal-api/getPolicy',
  getListProfie: 'billing-portal-api/listProfile',
  bindEndpoint: 'billing-portal-api/bind',
  policiesEndpoint: 'billing-portal-api/policies/',
  bondPostPayment: 'billing-portal-api/bond/postPayment/',
  getBondsByEmail: 'billing-portal-api/bonds/',
  billingInquiry: 'billing-portal-api/billingInquiry/',
  printPolicyEndpoint: 'billing-portal-api/issueletter',
  getPortals: '/aip-admin-api/getPortals/',
  initializePaymentUsEndPoint: 'billing-portal-api/ssoToken',
  addCard: '/billing-portal-api/addCard',
  sendUpdateCardEmail: '/billing-portal-api/sendUpdateCardEmail',
  //reconcilePayment: '/billing-portal-api/reconcilePayment',
  //getSignature: '/aip-admin-api/getUserSignature',
  //updateSignature: '/aip-admin-api/saveUserSignature',
  //serviceEndPortals: '/aip-admin-api/getPortals',
  // serviceEndPointGetRolesAgenciesAndProducts: '/aip-admin-api/getRolesAgenciesAndProducts',
  //serviceEndPointUserDetail: '/getUserdetails/',

  serviceEndPointaddUser: '/aip-admin-api/addUser',
  adminPortalEndpoint: '/admin',
  serviceEndPointsContentServer: 'audit/resourcePath?appName=',
  userClaims: 'aipsecurityapi/loginUnregisteredUserClaims',
  products: { canopy: 'ea', essentialpl: 'pl', 'netsafe-primary': 'cyber' } as Record<string, string>,
  product_mapping: {
    ea: 'canopy',
    pl: 'essentialpl',
    cyber: 'netsafe-primary',
    canopy: 'canopy',
    essentialpl: 'essentialpl',
    'netsafe-primary': 'netsafe-primary',
  } as Record<string, string>,
  lob: 'professioanlliability',
  getCOIDetails: 'billing-portal-api/getCertificateOfInsurancePDF/',
  paymentusMigrationDate: '04/10/2025',
  maintenanceStartDate: '07/15/2022 22:00:00 GMT-0400 (Eastern Daylight Time)',
  maintenanceEndDate: '07/16/2022 02:00:00 GMT-0400 (Eastern Daylight Time)',
  warnMinutesBefore: 5760,
};
